
<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.locationcarrierzone"
        context="pivot"
        :primary-fields="['location.postcode', 'location.suburb', 'location.state', 'zone', 'zone_parent.desc']"
        :hidden-fields="['carrier']"
        @apply="reload"
        @ready="load"
      />
    </el-col>
    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card shadow="never">
        <LocationCarrierZonesTable
          ref="contactTable"
          v-loading="isLoading"
          :lczs="lczs"
          @refresh="reload"
          @edit="edit"
        />
        <br>
        <div style="text-align: center;">
          <el-pagination
            :current-page.sync="lczs.page"
            :page-size.sync="lczs.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="lczs.total"
            @size-change="reload"
            @current-change="reload"
          />
        </div>
        <LocationCarrierZoneForm
          ref="lcz"
          :lcz="lcz"
          :operator="create"
          @refresh="reload"
        />
        <Preview
          v-if="isShowPreview"
          title="Zone Export"
          :is-show.sync="isShowPreview"
          :configuration="configuration"
        />
        <ZoneImportForm
          v-if="isShowImport"
          :is-show.sync="isShowImport"
          :carrier-id="this.$route.params.carrierId"
        />
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import LocationCarrierZonesTable from '@/components/Application/Manage/Carriers/LocationCarrierZonesTable'
import LocationCarrierZoneForm from '@/components/Application/Manage/Carriers/LocationCarrierZoneForm'
import Filters from '@/components/Filters/Simplified'
import Filter, { IS } from '@/plugins/sdk/Filter'
import { CREATE } from '@/plugins/user'
import ZoneImportForm from '@/components/Application/Manage/Carriers/ZoneImportForm'
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    LocationCarrierZonesTable,
    LocationCarrierZoneForm,
    Filters,
    ZoneImportForm,
    Preview
  },
  data () {
    return {
      title: 'Zones',
      breadcrumb: {
        name: 'Zones',
        route: { name: 'manage-carriers-carrier-locationcarrierzones', params: { carrierId: this.$route.params.carrierId } }
      },
      actions: [
        [
          {
            name: 'Import',
            icon: ['fal', 'upload'],
            event: () => {
              this.isShowImport = true
            }
          },
          {
            name: 'Export',
            icon: ['fal', 'download'],
            event: () => {
              this.isShowPreview = true
            }
          }
        ],
        [
          {
            hidden: this.$user.cannot(CREATE, 'carrier_locationzone'),
            name: 'Create',
            icon: ['fal', 'plus'],
            event: () => {
              this.showForm()
            }
          },
          {
            name: 'Refresh',
            icon: ['fal', 'sync'],
            event: () => {
              this.reload()
            }
          }
        ]
      ],
      isLoading: true,
      isSaving: false,
      lczs: [],
      create: true,
      lcz: {
        carrier: {},
        location: { postcode: null, suburb: null, state: null, custom: null },
        zone: { desc: '' },
        zone_parent: { desc: '' }
      },
      filters: [],
      isShowImport: false,
      isShowPreview: false,
      configuration: {
        report: 'CarrierZones',
        params: {
          carrierId: this.$route.params.carrierId
        }
      }
    }
  },
  methods: {
    load () {
      this.isLoading = true
      this.$sdk.locationcarrierzone.list((builder) => {
        builder.context = { resource: 'pivot' }
        builder.include = ['carrier', 'location', 'zone', 'zone_parent', 'hub', 'user']
        builder.order = 'created_at:desc'
        builder.filters = [
          new Filter('carrier', IS, this.$route.params.carrierId, true, true),
          ...this.filters
        ]
      }).then(res => {
        this.lczs = res
        this.isLoading = false
      })
    },
    async reload () {
      try {
        this.isLoading = true
        await this.lczs.reload(builder => {
          builder.filters = [
            new Filter('carrier', IS, this.$route.params.carrierId, true, true),
            ...this.filters
          ]
        })
      } catch {
        this.$message.error('An error occurred while loading the Location time zones')
      } finally {
        this.isLoading = false
        this.reset()
      }
    },
    showForm (row) {
      this.reset()
      if (row) {
        this.create = false
        this.$refs.lcz.showDialog()
        this.lcz = row
        if (!this.lcz.zone_parent) {
          this.lcz.zone_parent = {
            desc: ''
          }
        }
      } else {
        this.create = true
        this.$refs.lcz.showDialog()
        this.$sdk.carrier.read(this.$route.params.carrierId, builder => {
        }).then(res => {
          this.isLoading = false
          this.lcz.carrier = res
        })
      }
    },
    edit (row) {
      this.showForm(row)
    },
    reset () {
      this.lcz = {
        carrier: {},
        location: { postcode: null, suburb: null, state: null, custom: '' },
        zone: { desc: null, created_at: null, updated_at: null },
        zone_parent: { desc: null, created_at: null, updated_at: null }
      }
    }
  }
}
</script>
